// extracted by mini-css-extract-plugin
export var contentSection = "_7-8";
export var imageSection = "_7-1";
export var productGrid = "_7-0";
export var productImage = "_7-3";
export var productImageContainer = "_7-2";
export var productInfo = "_7-9";
export var purchaseControls = "_7-a";
export var quantityInput = "_7-c";
export var selectedThumbnail = "_7-6";
export var thumbnailContainer = "_7-4";
export var thumbnailImage = "_7-7";
export var thumbnailItem = "_7-5";
export var variantSelect = "_7-b";